<template>
  <div class="bottom-top-container" ref="bottomParent">
    <div class="mobile-bottom-line-container">
      <div class="bottom-button" @click="goNext" style="color:#4bced0;">
        <div class="bottom-icon">
          <i class="el-icon-check" style="color:#4bced0;" />
        </div>
        {{ processStatus && processDetail.process.isEndpoint && processDetail.button.find(b => b.buttonKey ==
          'wf_pass') ? "办结" : "转交下一步" }}
      </div>
      <div class="bottom-button" v-if="showCheckButton" @click="checkDialogShow = true" style="color:#edac69;">
        <div class="bottom-icon">
          <i class="el-icon-edit-outline" style="color:#edac69;" />
        </div>
        核定额度
      </div>
      <div class="bottom-button" @click="goBack" style="color:#fb6260;">
        <div class="bottom-icon">
          <i class="el-icon-refresh-left" style="color:#fb6260;" />
        </div>
        退回
      </div>
      <!-- <div class="bottom-button" @click="dialogShow = true;showType='comment'">
        <div class="bottom-icon">
          <i class="el-icon-chat-square" />
        </div>
        会签
      </div> -->

      <!-- 弹框 -->
      <a-drawer :visible="dialogShow" placement="bottom" :closable="false" :mask="true" :maskClosable="true" height="25%"
        zIndex="1001" :destroyOnClose="true" @close="dialogShow = false" :getContainer="() => $refs.bottomParent">
        <div class="mobile-audit-popup-content">
          <div class="opinion-title">{{ showType == 'next' ? requiredObject.label : '会签意见' }}</div>
          <el-input class="form-content" type="textarea" :placeholder="showType == 'next' ? '请输入审批意见' : '请输入会签意见'"
            v-model="submitText" maxlength="100" rows="3">
          </el-input>
          <div class="submit-button-con">
            <el-button type="primary" round @click="submitForm">确定</el-button>
          </div>
        </div>
      </a-drawer>

      <!-- 核定额度弹框 -->
      <a-drawer :visible="checkDialogShow" placement="bottom" :closable="false" :mask="true" :maskClosable="true"
        :destroyOnClose="true" height="35%" zIndex="1001" @close="checkDialogShow = false"
        :getContainer="() => $refs.bottomParent">
        <div class="mobile-check-credit-content">
          <div class="credit-title">核定额度</div>
          <div class="credit-form-content">
            是否按发起额度通过？
          </div>
          <div class="check-box-content">
            <a-radio-group v-model="isCheckCredit">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="2">否</a-radio>
            </a-radio-group>
          </div>
          <div class="credit-content" v-if="isCheckCredit == 2">
            <el-input placeholder="请输入修改额度" v-model="checkCredit" type="number">
              <template slot="append">元</template>
            </el-input>
          </div>
          <div class="credit-button">
            <div class="button-one" @click="checkDialogShow = false">取消</div>
            <div class="button-line"></div>
            <div class="button-one" @click="changeCredit">确定</div>
          </div>
        </div>
      </a-drawer>

      <a-drawer :visible="rollBackShow" placement="bottom" :closable="false" :mask="true" :maskClosable="true"
        :destroyOnClose="true" height="75%" zIndex="1001" @close="rollBackShow = false"
        :getContainer="() => $refs.bottomParent">
        <div class="mobile-audit-roll-back-container">
          <div class="roll-back-title">请选择退回步骤</div>
          <div class="roll-back-list">
            <template v-for="(item, index) in nodeList">
              <div class="option-one" :key="`${item.nodeId}_${index}`">
                <div class="option-title">第{{ index + 1 }}步&nbsp;{{ item.nodeName }}</div>
                <div class="option-content">
                  <div class="content-left">
                    <div class="roll-back-person">主办：<span>{{ item.userName }}</span></div>
                    <div class="roll-back-time">办结时间：{{ item.endTime }}</div>
                  </div>
                  <div class="content-right">
                    <el-radio class="node-radio" v-model="nodeCheckIndex" :label="index"> </el-radio>
                  </div>
                </div>
                <!-- <el-radio class="node-radio" v-model="nodeCheckIndex" :label="index">第{{index + 1}}步&nbsp;{{item.nodeName}}</el-radio>
                <div class="node-tip">主办：{{item.userName}}&nbsp;&nbsp;&nbsp;办结：{{item.endTime}}</div> -->
              </div>
            </template>
          </div>

          <div class="comment-content">
            <div class="comment-title">请输入退回意见:</div>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
              v-model="rollBackComment">
            </el-input>
          </div>

          <div class="submit-button-con">
            <el-button type="primary" round @click="rollBack">退回</el-button>
          </div>
        </div>
      </a-drawer>
      <a-drawer :visible="showSelectPeople" placement="bottom" :closable="false" :mask="true" :maskClosable="true"
        :destroyOnClose="true" height="40%" zIndex="1001" @close="showSelectPeople = false"
        :getContainer="() => $refs.bottomParent">

        <div class="mobile-check-credit-content">
          <div>
            <el-form ref="form" :model="selectPeopleData" label-width="120px">
              <template v-for="(item, index) in selectPeopleList">
                <el-form-item :key="index" :label="`${item.taskDefName}:`" prop="">
                  <el-select v-model="selectPeopleData[index].manager" size="small">
                    <el-option v-for="(p, i) in item.personList" :key="i" :label="p" :value="p">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-form>
          </div>
          <div class="credit-button">
            <div class="button-one" @click="showSelectPeople = false">取消</div>
            <div class="button-line"></div>
            <div class="button-one" @click="selectPeopleFlowNext">确定</div>
          </div>
        </div>
      </a-drawer>
      <!-- <nut-popup v-model="rollBackShow" position="bottom" :style="{ height: '75%' }" >

      </nut-popup> -->
    </div>
  </div>
</template>
<script>
import workFlow from '@/mixins/workFlow'
import { mapGetters } from "vuex";
import { getNextTaskInfo } from "@/api/workFlow/workFlow";
export default {
  name: 'MobileBottomLine',
  mixins: [workFlow],
  data() {
    return {
      isCheckCredit: 1,
      checkCredit: 0,
      checkDialogShow: false,
      nodeCheckIndex: 0,
      rollBackComment: '',
      nodeList: [],
      selectPeopleList: [],
      selectPeopleData: [],
      showType: 'next',
      dialogShow: false,
      rollBackShow: false,
      requiredObject: {},
      submitText: '',
      showSelectPeople: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    processStatus() {
      if (this.processDetail && this.processDetail.process) {
        return this.processDetail.process.status == 'todo' ? true : false
      } else {
        return false
      }
    },
  },
  props: {
    processDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },

    formDetailData: {
      type: Object,
      default: () => {
        return {}
      }
    },

    /**
     * @param {String} status 流程状态todo/done
     */
    status: {
      type: String,
      default: 'done'
    },

    mobileFormChange: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 是否显示核定额度
    showCheckButton: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    formDetailData: {
      handler(val) {
        if (val.allAppForm) {
          // this.dealMobileFomrConfig(val)
          this.dealForm(val)
        }
      },
      deep: true
    },

    mobileFormChange: {
      handler(val) {
        let filterResult = val.filter(item => { return item.required == true && item.disabled == false })
        if (filterResult.length > 0) this.submitText = filterResult[0].variables
      },
      deep: true
    }
  },
  mounted() {
    if (this.formDetailData.allAppForm) {
      this.dealForm(this.formDetailData)
      // this.dealMobileFomrConfig(this.formDetailData)
      // let filterResult = this.mobileFormConifg.filter(item => {return item.required == true && item.disabled == false})
      // this.submitText = filterResult[0].variables
    }
  },
  methods: {
    changeCredit() {
      let params = {
        isCredit: this.isCheckCredit,
        credit: this.isCheckCredit == 1 ? 0 : this.checkCredit
      }
      this.$emit('setCredit', params)
    },
    dealForm(config) {
      this.dealMobileFomrConfig(config)
      let filterResult = this.mobileFormConifg.filter(item => { return item.required == true && item.disabled == false })
      if (filterResult.length > 0) this.submitText = filterResult[0].variables
    },
    async goNext() {
      // console.info(this.mobileFormConifg, 'mobileFormConifg')
      // 提取需要输入的内容
      let filterResult = []
      filterResult = this.mobileFormConifg.filter(item => { return item.required == true && item.disabled == false })
      // console.info(this.requiredObject, 'this.requiredObject')
      let self = this
      // 判断下一步流程是否需要指定对象
      if (this.processDetail.process.doSelect && this.processDetail.process.doSelect == 1) {
        // 弹出人员选择框
        this.selectPeopleData = []
        let res = await getNextTaskInfo({ taskId: this.processDetail.process.taskId })
        // console.info(res, 'getNextTaskInfo')
        this.selectPeopleList = res.data.data.options
        // 处理绑定数据
        this.selectPeopleList.map(item => {
          self.selectPeopleData.push({
            manager: '',
            taskDefId: item.taskDefId,
            isSelected: true
          })
        })
        this.showSelectPeople = true
      } else {
        if (filterResult.length > 0) {
          this.requiredObject = filterResult[0]
          this.dialogShow = true
          this.showType = 'next'
        } else {
          // 当前用户无需填写意见
          this.$emit('flowNext', {})
        }
      }

    },
    selectPeopleFlowNext() {
      let formComplete = true
      this.selectPeopleData.map(item => {
        if (item.manager == '') {
          formComplete = false
        }
      })
      if (formComplete) {
        this.showSelectPeople = false
        let filterResult = []
        filterResult = this.mobileFormConifg.filter(item => { return item.required == true && item.disabled == false })
        if (filterResult.length > 0) {
          this.requiredObject = filterResult[0]
          this.dialogShow = true
          this.showType = 'next'
        } else {
          // 当前用户无需填写意见
          this.$emit('flowNext', {},this.selectPeopleData)
        }
      } else {
        this.$message.warning('请先选择人员再提交')
      }
    },
    async goBack() {
      this.nodeList = await this.queryBackStepList(this.processDetail.process.taskId)
      if (this.nodeList.length > 0) {
        this.rollBackShow = true
      } else {
        // this.$notify.warn('暂无可回退节点')
        this.$message({
          message: '暂无可回退节点',
          type: 'warning'
        })
      }
    },

    async rollBack() {
      if (this.rollBackComment == '') {
        this.$message({
          message: '请填写退回意见',
          type: 'warning'
        })
        return
      }
      const { nodeId } = this.nodeList[this.nodeCheckIndex]
      // this.$emit('rollBack', nodeId, this.rollBackComment)
      let res = await this.taskFlowBack(this.processDetail.process.taskId, nodeId, this.rollBackComment)
      if (res.data.code == 200) {
        this.rollBackShow = false
        // this.$message({
        //   message: '退回成功',
        //   type: 'success'
        // })        
        this.$emit("refreshData")
      }
    },

    closeDialog() {
      this.dialogShow = false
      this.rollBackShow = false
    },

    submitForm() {
      if (this.submitText.trim() == '') {
        // this.$notify.warn('请填写审批意见后提交');
        this.$message({
          message: '请填写审批意见后提交',
          type: 'warning'
        })
      } else {
        if (this.showType == 'next') {
          let date = new Date()
          let year = date.getFullYear()
          let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
          let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
          let finallyData = `${year}-${month}-${day}`
          let params = {
            opinionContent: this.submitText,
            opinionDate: `${this.userInfo.user_name} ${finallyData}`
          }
          // 处理提交数据
          if (this.requiredObject.component == 'wf-users-opinion') {
            const submitParams = {
              opinionContent: this.submitText,
              opinionDate: finallyData,
              opinionName: this.userInfo.user_name,
              opinionSign: `${this.userInfo.user_name} ${finallyData}`
            }
            if (Array.isArray(JSON.parse(this.mobileFormData[this.requiredObject.prop])) && JSON.parse(this.mobileFormData[this.requiredObject.prop]).length > 0) {
              let opinionData = JSON.parse(this.mobileFormData[this.requiredObject.prop])
              let samePeople = opinionData.filter((item, index) => { item.opinionName == this.userInfo.user_name })
              // 判断是否重复填写意见
              if (samePeople.length > 0) {
                opinionData.map(item => {
                  if (item.opinionName == this.userInfo.user_name) item.opinionContent = params.opinionContent
                })
                this.mobileFormData = JSON.stringify(opinionData)
              } else {
                opinionData.push(submitParams)
                this.mobileFormData[this.requiredObject.prop] = JSON.stringify(opinionData)
              }
            } else {
              this.mobileFormData[this.requiredObject.prop] = JSON.stringify([submitParams])
            }
          } else {
            this.mobileFormData[this.requiredObject.prop] = JSON.stringify(params)
          }
          this.$emit("flowNext", this.mobileFormData,this.selectPeopleData)
        } else {
          // 提交会签意见
          this.saveMobileComment(this.submitText)
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/ .ant-drawer-content {
  background-color: #f9f9f9;
}

/deep/ button.el-button.el-button--primary.is-round {
  padding: 0.25rem 0.7rem;
  font-size: .32rem;
}

/deep/ .el-radio__label {
  display: none;
}

/deep/ .el-radio {
  width: 0.5rem;
  height: 0.5rem;
}

/deep/ .el-message {
  min-width: 7rem !important;
}

.mobile-bottom-line-container {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 1.8rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);

  .bottom-button {
    font-size: 0.38rem;
    text-align: center;
    width: 2rem;

    i {
      font-size: .5rem;
      font-weight: 900;
    }
  }

  /deep/ .ant-drawer-body {
    height: 100% !important;

    .audit-popup-content {
      width: 100%;
      height: 100%;
      padding: .2rem .3rem;

      .opinion-title {
        font-size: 0.38rem;
        line-height: .8rem;
        height: .8rem;
        color: #333;
      }

      .submit-button-con {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        /* height: 1rem; */
        margin-top: 0.2rem;
      }
    }

    .mobile-audit-roll-back-container {
      background-color: #f9f9f9;
      width: 100%;
      height: 100%;

      .roll-back-title {
        width: 100%;
        text-align: center;
        font-weight: 600;
        color: #333;
        font-size: .45rem;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
        background-color: #fff;
      }

      .roll-back-list {
        .option-one {
          .option-title {
            width: 100%;
            padding: .25rem .3rem;
            color: #999;
            font-size: 0.38rem;
          }

          .option-content {
            background-color: #fff;
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: .2rem .3rem;
            align-items: center;
            border-top: 0.5px solid #f2f2f2;
            border-bottom: 0.5px solid #f2f2f2;

            .content-left {
              font-size: 0.38rem;

              .roll-back-person {
                color: #333;

                span {
                  color: #409EFF;
                }
              }

              .roll-back-time {
                color: #999;
                font-size: 0.38rem;
              }
            }
          }
        }
      }

      .comment-content {
        width: 100%;
        padding: 0.2rem 0.3rem 0.3rem;
        background-color: #fff;
        margin-top: 0.25rem;
        border-top: 0.5px solid #f2f2f2;
        border-bottom: 0.5px solid #f2f2f2;

        .comment-title {
          font-size: 0.38rem;
          color: #999;
          line-height: .75rem;
        }

        .el-textarea {
          font-size: 0.38rem;
          color: #333;
        }
      }

      .submit-button-con {
        width: 70%;
        margin-top: 0.25rem;
        text-align: center;
        margin: 0.25rem auto 0;

        .el-button {
          width: 100%;
        }
      }
    }
  }


}
</style>
<style lang="scss">
.ant-drawer-header {
  display: none;
}

.ant-drawer-body {
  padding: 0;
  width: 100%;
  height: 100%;

  .mobile-check-credit-content {
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 0.2rem 0.3rem 0 .3rem;
    position: relative;
    background-color: #fff;

    .credit-title {
      font-weight: 600;
      font-size: .42rem;
      color: rgb(51, 51, 51);
      padding: .3rem 0;
    }

    .credit-form-content {
      font-size: 0.38rem;
      color: rgb(51, 51, 51);
    }

    .check-box-content {
      line-height: 1.2rem;
    }

    .credit-content {
      width: 70%;
      margin: .3rem auto 0;
    }

    .credit-button {
      position: absolute;
      width: 100%;
      height: 1.2rem;
      left: 0;
      bottom: 0;
      border-top: 1px solid #f3f3f3;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fff;

      .button-one {
        width: 49%;
        height: 100%;
        line-height: 1.2rem;
        text-align: center;
        color: #409EFF;
      }

      .button-line {
        width: 1px;
        height: 100%;
        background-color: #f3f3f3;
      }
    }
  }

  .mobile-audit-popup-content {
    width: 100%;
    height: 100%;
    padding: .2rem .3rem;

    .opinion-title {
      font-size: 0.38rem;
      line-height: .8rem;
      height: .8rem;
      color: #333;
    }

    .submit-button-con {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      /* height: 1rem; */
      margin-top: 0.2rem;
    }
  }

  .mobile-audit-roll-back-container {
    background-color: #f9f9f9;
    width: 100%;
    height: 100%;

    .roll-back-title {
      width: 100%;
      text-align: center;
      font-weight: 600;
      color: #333;
      font-size: .45rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
      background-color: #fff;
    }

    .roll-back-list {
      .option-one {
        .option-title {
          width: 100%;
          padding: .25rem .3rem;
          color: #999;
          font-size: 0.38rem;
        }

        .option-content {
          background-color: #fff;
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: .2rem .3rem;
          align-items: center;
          border-top: 0.5px solid #f2f2f2;
          border-bottom: 0.5px solid #f2f2f2;

          .content-left {
            font-size: 0.38rem;

            .roll-back-person {
              color: #333;

              span {
                color: #409EFF;
              }
            }

            .roll-back-time {
              color: #999;
              font-size: 0.38rem;
            }
          }
        }
      }
    }

    .comment-content {
      width: 100%;
      padding: 0.2rem 0.3rem 0.3rem;
      background-color: #fff;
      margin-top: 0.25rem;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;

      .comment-title {
        font-size: 0.38rem;
        color: #999;
        line-height: .75rem;
      }

      .el-textarea {
        font-size: 0.38rem;
        color: #333;
      }
    }

    .submit-button-con {
      width: 70%;
      margin-top: 0.25rem;
      text-align: center;
      margin: 0.25rem auto 0;

      .el-button {
        width: 100%;
      }
    }
  }
}
</style>